import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {

  public loginForm : boolean = false;
  constructor(
    private router : Router,
    private authService : AuthenticationService
  ) { }

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl('profil');
    } else {
      this.router.navigateByUrl('accueil');
    }
  }

  shwowLoginForm(){
    this.loginForm = !this.loginForm;    
  }
}
